import { Flex } from 'components/shared/flex'
import { ThemeContext } from 'contexts/theme_context'
import { PcrRun } from 'entities/pcr_run'
import { useContext } from 'react'
import { Table } from 'react-bootstrap'
import { Form } from 'utils/hooks'

export type DispenseAmount = {
    probeMix?: number
    dnaMix?: number
    standardProbeMix?: number
    standardDnaMix?: number
}

type Props = {
    pcrRun: PcrRun
    form: Form<DispenseAmount>
}

export const ExpProtocolV2 = (props: Props) => {
    const theme = useContext(ThemeContext)

    return (
        <div className="child-margin-c-15" style={{ fontWeight: 'bold', marginRight: 0 }}>
            {(() => {
                const replicate = 3
                const dnaDispenseCount = 8
                const probeDispenseCount = 1

                const totalWellOfProbe = props.pcrRun.dnaSet!.length * replicate
                const amountOfMasterMix = totalWellOfProbe * 6 + probeDispenseCount * 14
                const amountOfProbe = Math.round((totalWellOfProbe * 0.6 + probeDispenseCount * 1.4) * 100) / 100
                const probeMix = Math.floor(((amountOfMasterMix + amountOfProbe) / probeDispenseCount) * 10) / 10

                const totalWellOfDna = props.pcrRun.probes!.length * replicate
                const amountOfNFW = Math.round((totalWellOfDna * 5.1 + dnaDispenseCount * 10.2) * 10) / 10
                const amountOfDna = Math.round((totalWellOfDna * 0.3 + dnaDispenseCount * 0.6) * 10) / 10
                const dnaMix = Math.round((amountOfNFW + amountOfDna) * 10) / 10

                if (!props.form.object.probeMix) {
                    props.form.update((f) => {
                        f.probeMix = probeMix
                        f.dnaMix = dnaMix
                        f.standardProbeMix = 35.2
                        f.standardDnaMix = 27
                    })
                }

                return (
                    <>
                        <div style={{ backgroundColor: 'white', marginRight: 10 }}>
                            <div style={{ background: theme.brand, padding: '5px 15px', color: 'white' }}>各種数量</div>
                            <div style={{ padding: 10 }}>
                                <Table style={{ backgroundColor: 'white', textAlign: 'center', verticalAlign: 'bottom' }}>
                                    <tbody>
                                        <tr>
                                            <th>cDNA計算基準</th>
                                            <th>Probe数</th>
                                            <th>1Probe総well数</th>
                                            <th>1cDNA総well数</th>
                                        </tr>
                                        <tr>
                                            <td>{dnaDispenseCount}</td>
                                            <td>{probeDispenseCount}</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>cDNA数 x 3</div>
                                                {totalWellOfProbe}
                                            </td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>Probe数 x 3</div>
                                                {totalWellOfDna}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                        <Flex>
                            <div>
                                <div style={{ backgroundColor: 'white', marginRight: 10 }}>
                                    <div style={{ background: theme.brand, padding: '5px 15px', color: 'white' }}>QC用プローブのReaction Mixを準備する</div>
                                    <div style={{ padding: 10 }}>
                                        <Table style={{ width: 'auto', backgroundColor: 'white', textAlign: 'center', verticalAlign: 'bottom' }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>1probe総well数</div>
                                                        <div>{totalWellOfProbe}</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>
                                                        <div>6</div>
                                                    </td>
                                                    <td>+</td>
                                                    <td>14</td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>Master Mix量</div>
                                                        <div>{amountOfMasterMix}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: 120, position: 'relative' }}>
                                                        <div style={{ fontSize: 11 }}>1Probe数well数</div>
                                                        <div>3</div>
                                                        <div style={{ position: 'absolute', top: -2, left: 14, fontSize: 10, color: 'red' }}>
                                                            qPCR_standard用
                                                        </div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>6</td>
                                                    <td>+</td>
                                                    <td>
                                                        <div style={{ width: 60 }}>14</div>
                                                    </td>
                                                    <td>=</td>
                                                    <td>
                                                        <div>
                                                            <div style={{ fontSize: 11 }}>MasterMix量</div>
                                                            <div>32</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>1probe総well数</div>
                                                        <div>{totalWellOfProbe}</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>
                                                        <div>0.6</div>
                                                    </td>
                                                    <td>+</td>
                                                    <td>1.4</td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>Probe量</div>
                                                        <div>{amountOfProbe}</div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ width: 120, position: 'relative' }}>
                                                        <div style={{ fontSize: 11 }}>1Probe数well数</div>
                                                        <div>3</div>
                                                        <div style={{ position: 'absolute', top: -2, left: 14, fontSize: 10, color: 'red' }}>
                                                            qPCR_standard用
                                                        </div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>0.6</td>
                                                    <td>+</td>
                                                    <td>
                                                        <div style={{ width: 60 }}>1.4</div>
                                                    </td>
                                                    <td>=</td>
                                                    <td>
                                                        <div>
                                                            <div style={{ fontSize: 11 }}>Probe量</div>
                                                            <div>3.2</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>MasterMix量</div>
                                                        <div>{amountOfMasterMix} + 32</div>
                                                    </td>
                                                    <td>+</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>Probe量</div>
                                                        <div>{amountOfProbe} + 3.2</div>
                                                    </td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>Total</div>
                                                        <div>{Math.floor((amountOfMasterMix + amountOfProbe + 32 + 3.2) * 10) / 10}</div>
                                                    </td>
                                                    {/* <td>÷</td>
                                                    <td>{probeDispenseCount}</td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>分注量</div>
                                                        <div>{probeMix}</div>
                                                    </td> */}
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                                <div style={{ backgroundColor: 'white', marginRight: 10 }}>
                                    <div style={{ background: theme.brand, padding: '5px 15px', color: 'white' }}>バイオマーカーのReaction Mixを準備する</div>
                                    <div style={{ padding: 10 }}>
                                        <Table style={{ width: 'auto', backgroundColor: 'white', textAlign: 'center', verticalAlign: 'bottom' }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>1probe総well数</div>
                                                        <div>{totalWellOfProbe}</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>
                                                        <div>6</div>
                                                    </td>
                                                    <td>+</td>
                                                    <td>14</td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>Master Mix量</div>
                                                        <div>{amountOfMasterMix}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>1probe総well数</div>
                                                        <div>{totalWellOfProbe}</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>
                                                        <div>0.6</div>
                                                    </td>
                                                    <td>+</td>
                                                    <td>1.4</td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>Probe量</div>
                                                        <div>{amountOfProbe}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>MasterMix量</div>
                                                        <div>{amountOfMasterMix}</div>
                                                    </td>
                                                    <td>+</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>Probe量</div>
                                                        <div>{amountOfProbe}</div>
                                                    </td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>Total</div>
                                                        <div>{amountOfMasterMix + amountOfProbe}</div>
                                                    </td>
                                                    {/* <td>÷</td>
                                                    <td>{probeDispenseCount}</td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>分注量</div>
                                                        <div>{probeMix}</div>
                                                    </td> */}
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div style={{ backgroundColor: 'white', marginRight: 10 }}>
                                    <div style={{ background: theme.brand, padding: '5px 15px', color: 'white' }}>
                                        計算した本数分のReaction Mix を8連チューブに混合する
                                    </div>
                                    <div style={{ padding: 10 }}>
                                        <Table style={{ width: 'auto', backgroundColor: 'white', textAlign: 'center', verticalAlign: 'bottom' }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>1cDNA総well数</div>
                                                        <div>{totalWellOfDna}</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>5.1</td>
                                                    <td>+</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>分注数</div>
                                                        <div style={{ width: 60 }}>{dnaDispenseCount}</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>10.2</td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>NFW量</div>
                                                        <div>{amountOfNFW}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>1cDNA総well数</div>
                                                        <div>{totalWellOfDna}</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>0.3</td>
                                                    <td>+</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>分注数</div>
                                                        <div style={{ width: 60 }}>{dnaDispenseCount}</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>
                                                        <div>{0.6}</div>
                                                    </td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>cDNA量</div>
                                                        <div>{amountOfDna}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>NFW量</div>
                                                        <div>{amountOfNFW}</div>
                                                    </td>
                                                    <td>+</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>cDNA量</div>
                                                        <div>{amountOfDna}</div>
                                                    </td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>Total</div>
                                                        <div>{dnaMix}</div>
                                                    </td>
                                                    <td colSpan={4}>
                                                        <div style={{ fontSize: 11 }}>※1wellあたりの分注量は96wellに記載</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>

                                <div style={{ backgroundColor: 'white', marginRight: 10 }}>
                                    <div style={{ background: theme.brand, padding: '5px 15px', color: 'white' }}>Standard cDNA Reaction Mix</div>
                                    <div style={{ padding: 10 }}>
                                        <Table style={{ width: 'auto', backgroundColor: 'white', textAlign: 'center', verticalAlign: 'bottom' }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>1cDNA数well数</div>
                                                        <div>3</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>5.1</td>
                                                    <td>+</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>分注数</div>
                                                        <div>6</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>
                                                        <div>10.2</div>
                                                    </td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>NFW量</div>
                                                        <div>153</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>1cDNA数well数</div>
                                                        <div>3</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>0.3</td>
                                                    <td>+</td>
                                                    <td>
                                                        <div style={{ width: 60 }}>6</div>
                                                    </td>
                                                    <td>x</td>
                                                    <td>
                                                        <div style={{ width: 60 }}>0.6</div>
                                                    </td>
                                                    <td>=</td>
                                                    <td>
                                                        <div>
                                                            <div style={{ fontSize: 11 }}>cDNA量</div>
                                                            <div>9</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: 120 }}>
                                                        <div style={{ fontSize: 11 }}>NFW量</div>
                                                        <div>153</div>
                                                    </td>
                                                    <td>+</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>cDNA量</div>
                                                        <div>9</div>
                                                    </td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>Total</div>
                                                        <div>162</div>
                                                    </td>
                                                    <td>÷</td>
                                                    <td>6</td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>分注量</div>
                                                        <div>27</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </Flex>
                    </>
                )
            })()}
        </div>
    )
}
